/*
 * @Author: bianbinbin
 * @Date: 2023-12-19 14:52:23
 * @LastEditors: bianbinbin
 * @LastEditTime: 2023-12-19 15:48:43
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/job-execution.js
 */
const jobExecution = r => require.ensure([], () => r(require('@/views/jobExecution/jobExecution.vue'), 'jobExecution'))

const router = [
  {
    path: '/jobExecution',
    name: 'jobExecution',
    meta: {
      title: '工作执行情况'
    },
    component: jobExecution
  }
]

export default router
